export default __webpack_public_path__ + "static/media/main.0b86afc6.png";